import {Button, Checkbox, FormControlLabel, TextField, Theme, Typography} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {initialFilters} from './BillingPartyList';


const useStyles = makeStyles((theme: Theme) => ({
    root: {},
    content: {
        padding: theme.spacing(0, 3),
        flexGrow: 1
    },
    contentSection: {
        padding: theme.spacing(2, 0)
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    fieldGroup: {
        display: 'flex',
        alignItems: 'center'
    },
    field: {
        marginTop: 0,
        marginBottom: 0
    },
    flexGrow: {
        flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  radioGroup: {},
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  }
}));

export interface FilterValues {
    id?: number,
    email: string,
    first_name: string,
    last_name: string,
    disabledTrue: boolean,
    disabledFalse: boolean,
    hasPendingECheckPaymentsTrue: false,
    hasPendingECheckPaymentsFalse: false,
    primary_paying_memberTrue: false,
    primary_paying_memberFalse: false,
    is_group_leaderTrue: false,
    is_group_leaderFalse: false,
    has_pastdue_paymentsTrue: false,
    has_pastdue_paymentsFalse: false,
}

export const SearchFilter = (props: { applyFilters: (filters: FilterValues) => void, filters: FilterValues, initialFilters: FilterValues
}) => {
  const {filters } = props;
  const classes = useStyles();
  const [values, setValues] = useState({ ...filters });

    const handleClear = () => {
      props.applyFilters(initialFilters);
    };

    const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      event.persist();

      setValues(oldValues => ({
        ...oldValues,
        [event.target.name]: event.target.type === 'checkbox' ? (event.target as HTMLInputElement).checked : event.target.value
      }));
    };

    const applyFilters = () => {
      props.applyFilters(values);
    };

  return (
    <React.Fragment>
        <div className={classes.content}>
          <div className={classes.contentSection}>

              <div className={classes.formGroup}>

                  <div className={classes.fieldGroup}>
                      <TextField className={classes.field}
                                 fullWidth
                                 label="Party Id"
                                 name="id"
                                 onChange={handleFieldChange}
                                 value={values.id}
                                 variant="outlined"
                      />
                  </div>
              </div>

              <div className={classes.formGroup}>

                  <div className={classes.fieldGroup}>
                      <TextField className={classes.field}
                                 fullWidth
                                 label="Email"
                                 name="email"
                                 onChange={handleFieldChange}
                                 value={values.email}
                                 variant="outlined"
                      />
                  </div>
              </div>

          <div className={classes.formGroup}>
            <div className={classes.fieldGroup}>
              <TextField className={classes.field}
                         fullWidth
                         label="First Name"
                         name="first_name"
                         onChange={handleFieldChange}
                         value={values.first_name}
                         variant="outlined"
              />
              <TextField className={classes.field}
                         fullWidth
                         label="Last Name"
                         name="last_name"
                         onChange={handleFieldChange}
                         value={values.last_name}
                         variant="outlined"
              />
            </div>
          </div>


              <div className={classes.formGroup}>
                  <Typography component="span" gutterBottom variant="overline"
                              style={{paddingRight: 10}}>Disabled?</Typography>
                  <FormControlLabel
                      label="yes"
                      control={<Checkbox checked={values.disabledTrue} onChange={handleFieldChange}
                                         name="disabledTrue"/>}
                  />
                  <FormControlLabel
                      label="no"
                      control={<Checkbox checked={values.disabledFalse} onChange={handleFieldChange}
                                         name="disabledFalse"/>}
                  />
              </div>

              <div className={classes.formGroup}>
                  <Typography component="span" gutterBottom variant="overline"
                              style={{paddingRight: 10}}>Has Pending E-Check?</Typography>
                  <FormControlLabel
                      label="yes"
                      control={<Checkbox checked={values.hasPendingECheckPaymentsTrue} onChange={handleFieldChange}
                                         name="hasPendingECheckPaymentsTrue"/>}
                  />
                  <FormControlLabel
                      label="no"
                      control={<Checkbox checked={values.hasPendingECheckPaymentsFalse} onChange={handleFieldChange}
                                         name="hasPendingECheckPaymentsFalse"/>}
                  />
              </div>

              <div className={classes.formGroup}>
                  <Typography component="span" gutterBottom variant="overline"
                              style={{paddingRight: 10}}>Has Group Leader Override?</Typography><br/>
                  <FormControlLabel
                      label="yes"
                      control={<Checkbox checked={values.is_group_leaderTrue} onChange={handleFieldChange}
                                         name="is_group_leaderTrue"/>}
                  />
                  <FormControlLabel
                      label="no"
                      control={<Checkbox checked={values.is_group_leaderFalse} onChange={handleFieldChange}
                                         name="is_group_leaderFalse"/>}
                  />
              </div>

              <div className={classes.formGroup}>
                  <Typography component="span" gutterBottom variant="overline"
                              style={{paddingRight: 10}}>Has Past Due Payments?</Typography><br/>
                  <FormControlLabel
                      label="yes"
                      control={<Checkbox checked={values.has_pastdue_paymentsTrue} onChange={handleFieldChange}
                                         name="has_pastdue_paymentsTrue"/>}
                  />
                  <FormControlLabel
                      label="no"
                      control={<Checkbox checked={values.has_pastdue_paymentsFalse} onChange={handleFieldChange}
                                         name="has_pastdue_paymentsFalse"/>}
                  />
              </div>

          </div>
        </div>
        <div className={classes.actions}>
          <Button id="clear" fullWidth onClick={handleClear} variant="contained">
            <DeleteIcon className={classes.buttonIcon}/>
            Clear
          </Button>
          <Button id="submit" color="primary" fullWidth variant="contained" onClick={applyFilters}>
            Apply filters
          </Button>
        </div>
    </React.Fragment>
  );
};

export default SearchFilter;
